import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';

const FellowshipMain = () => {
  return (
    <main>
      
      <Breadcrumb title="Fellowship Programs" />

      <section className="py-12 px-4 md:px-20 bg-white text-gray-800">
        <div className="container mx-auto max-w-6xl">
            <br></br>
            <br></br>
          <h1 className="text-4xl font-bold text-blue-800 mb-6 text-center">Fellowship Programs</h1>
          <p className="text-center text-gray-500 text-sm italic mb-10">Advancing Specialized Medical Education at RIC</p>

          {/* <img
            src="https://via.placeholder.com/900x400"
            alt="Fellowship Programs"
            className="w-full rounded-lg shadow-lg mb-10"
          /> */}

          <Section title="What is a Fellowship?">
            A fellowship is an advanced training program for doctors who have completed their residency and wish to specialize further in a specific field of medicine. Fellowships at RIC offer hands-on experience with the latest technologies and mentorship from leading specialists.
          </Section>

          <Section title="Why Choose RIC for Your Fellowship?">
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>State-of-the-art facilities and diagnostic labs</li>
              <li>High patient volume for comprehensive clinical exposure</li>
              <li>Mentorship from experienced faculty</li>
              <li>Research opportunities with national and international collaboration</li>
            </ul>
          </Section>

          <Section title="Available Fellowship Disciplines">
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Cardiology</li>
              <li>Cardiothoracic Surgery</li>
              <li>Interventional Radiology</li>
              <li>Cardiac Anesthesia</li>
              <li>Critical Care Medicine</li>
            </ul>
          </Section>

          <Section title="Duration & Accreditation">
            <p>
              Most fellowships range from 1 to 3 years, depending on the discipline. All programs are accredited by the College of Physicians & Surgeons Pakistan (CPSP) or respective international boards, ensuring high standards of education.
            </p>
          </Section>

          <Section title="Eligibility Criteria">
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Completion of recognized residency (FCPS, MRCP, etc.)</li>
              <li>Valid PMDC registration</li>
              <li>Strong academic and clinical background</li>
              <li>Passion for subspecialty care and medical research</li>
            </ul>
          </Section>

          <Section title="Application Procedure">
            <ol className="list-decimal pl-5 mt-2 space-y-1">
              <li>Online Application Submission</li>
              <li>Document Verification</li>
              <li>Interview with Program Directors</li>
              <li>Final Selection & Induction</li>
            </ol>
          </Section>

          <Section title="Important Dates">
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Application Opens:</strong> July 1, 2025</li>
              <li><strong>Deadline:</strong> August 15, 2025</li>
              <li><strong>Interview Schedule:</strong> September 2025</li>
              <li><strong>Program Start Date:</strong> October 1, 2025</li>
            </ul>
          </Section>

          <Section title="Contact & Support">
            <p>Have questions? Reach out to our fellowship coordination team:</p>
            <p>Email: <a href="mailto:fellowship@ric.edu.pk" className="text-blue-600 underline">fellowship@ric.edu.pk</a></p>
            <p>Phone: <a href="tel:+92511234567" className="text-blue-600 underline">+92-51-1234567</a></p>
          </Section>

          <div className="text-center mt-10">
            <a
              href="/apply-fellowship"
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition duration-200"
            >
              Apply Now
            </a>
          </div>
        </div>
      </section>

   
    </main>
  );
};

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-700 mb-3">{title}</h2>
    <div className="text-gray-600">{children}</div>
  </div>
);

export default FellowshipMain;
